import { CodegenRw } from "../../io/codegenRw";
var AppContext = /** @class */ (function () {
    function AppContext(options, io) {
        this._injectionContext = this.injectionContext;
        this._options = options;
        this._io = io !== null && io !== void 0 ? io : new CodegenRw();
    }
    Object.defineProperty(AppContext.prototype, "injectionContext", {
        get: function () {
            return this._injectionContext;
        },
        enumerable: false,
        configurable: true
    });
    return AppContext;
}());
export { AppContext };
